import web from "@/core/middlewares/web";

let index = () =>
  import(/* webpackChunkName: "phone-numbers" */ "@/views/phone-numbers/Index");
let create = () =>
  import(
    /* webpackChunkName: "phone-numbers" */ "@/views/phone-numbers/Create"
  );
let edit = () =>
  import(/* webpackChunkName: "phone-numbers" */ "@/views/phone-numbers/Edit");

export default [
  {
    path: "phone-numbers",
    name: "admin.contacts.index",
    component: index,
    meta: {
      middleware: web,
      permissions: ["contacts:viewAny", "contacts:view"],
      title: "دفترچه تلفن",
    },
  },
  {
    path: "phone-numbers/create",
    name: "admin.contacts.create",
    component: create,
    meta: {
      middleware: web,
      permissions: ["contacts:create"],
      title: "ایجاد مخاطب",
    },
  },
  {
    path: "phone-numbers/:contact",
    name: "admin.contacts.edit",
    component: edit,
    meta: {
      middleware: web,
      permissions: ["contacts:update"],
      title: "ویرایش مخاطب",
    },
  },
];
